import { render, staticRenderFns } from "./WfViolationsModal.vue?vue&type=template&id=0dd2ee78&"
import script from "./WfViolationsModal.vue?vue&type=script&lang=js&"
export * from "./WfViolationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports